import { render, staticRenderFns } from "./Contracts.vue?vue&type=template&id=1aa9571c&scoped=true"
import script from "./Contracts.ts?vue&type=script&lang=ts&external"
export * from "./Contracts.ts?vue&type=script&lang=ts&external"
import style0 from "./Contracts.vue?vue&type=style&index=0&id=1aa9571c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa9571c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aa9571c')) {
      api.createRecord('1aa9571c', component.options)
    } else {
      api.reload('1aa9571c', component.options)
    }
    module.hot.accept("./Contracts.vue?vue&type=template&id=1aa9571c&scoped=true", function () {
      api.rerender('1aa9571c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/History/pages/Contracts/Contracts.vue"
export default component.exports